import * as Realm from 'realm-web'
import { ApolloClient, HttpLink, ApolloCache, NormalizedCacheObject } from '@apollo/client'

// Connect to your MongoDB Realm app
const app = new Realm.App(process.env.REACT_APP_REALM_ID as string)
// Gets a valid Realm user access token to authenticate requests
async function getValidAccessToken() {
  // Guarantee that there's a logged in user with a valid access token
  if (!app.currentUser) {
    // If no user is logged in, log in an anonymous user. The logged in user will have a valid
    // access token.
    await app.logIn(Realm.Credentials.anonymous())
  } else {
    // An already logged in user's access token might be stale. Tokens must be refreshed after
    // 30 minutes. To guarantee that the token is valid, we refresh the user's access token.
    await app.currentUser.refreshAccessToken()
  }
  return app?.currentUser?.accessToken
}

const createApolloClient = function (
  cache: ApolloCache<NormalizedCacheObject>,
): ApolloClient<NormalizedCacheObject> {
  const graphqlUri = process.env.REACT_APP_REALM_URL

  // Configure the ApolloClient to connect to your app's GraphQL endpoint
  return new ApolloClient({
    connectToDevTools: true,
    link: new HttpLink({
      uri: graphqlUri,
      // We define a custom fetch handler for the Apollo client that lets us authenticate GraphQL requests.
      // The function intercepts every Apollo HTTP request and adds an Authorization header with a valid
      // access token before sending the request.
      fetch: async (uri, options) => {
        const accessToken = await getValidAccessToken()
        return fetch(uri, {
          ...options,
          headers: { ...options?.headers, Authorization: `Bearer ${accessToken}` },
        })
      },
    }),
    cache,
  })
}

export default createApolloClient
